import { useSnapshot } from "valtio";
import { myactionsstore } from "./store-myactions";
import { configStore } from "../state/CommonState";
import { OneDatetable, OneInput5table } from "../mytasks/act-common";
import { useEffect, useState } from "react";
import { DtStore } from "../dt/DtStore";
import { DtMap } from "../dt/DtMap";
import TrackIcon from '../assets/images/track-icon.png'
import {origin_pickup_LCL,
    origin_pickup_fcl_FACTORY_FACTORY,
    origin_pickup_fcl_FACTORY_CFS,
    origin_pickup_fcl_CFS_FACTORY,
    origin_pickup_fcl_CFS_CFS,
    origin_pickup_AIR,
    destination_delivery_LCL,
    destination_delivery_fcl_FACTORY_FACTORY,
    destination_delivery_fcl_FACTORY_CFS,
    destination_delivery_fcl_CFS_CFS,
    destination_delivery_fcl_CFS_FACTORY,
    destination_delivery_AIR} from './dsr_static'
import { ACTUALSLIST, arrayListsinDsr, SHIPMENT_SCOPE, SHIPMENT_TYPE } from '../util/constants';

const  VEHICLE_ROW_ERROR_DEFAULT = {
    origin: true,
    destination: true,
    driver_number: true,
    vehicle: true,
    number_of_package: true,
    total_package: true,
};

export function Vviewmodal(props) {
const booking = props.data;
  const IMPORT_BOOKING = booking?.booking?.destinationCount === "India"
  const EXPORT_BOOKING = booking?.booking?.originCount === "India"
  const LCL_OR_AIR = booking.shipmentType === 'LCL' || booking.shipmentType === 'Air'


let originDateSelector;
let originDateSelector_Index = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    actual_time_arrival_at_warehouse: "ATA @ Warehouse 1",
  };
  let originDateSelector_LastIndex_For_LCL = {
    cargo_departed_for_port: "Cargo Departured for Port",
    cargo_arrival_cfs: "Cargo arrival at CFS",
  };
  let originDateSelector_LastIndex_For_Air = {
    cargo_departed_for_port: "Cargo Departured for AirPort",
    arrival_dispatch_airport: "Arrival @ Dispatch Airport",
  };
  let destinationDateSelector_Index_For_LCL = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Cargo Picked-up for Delivery",
    actual_time_arrival_at_warehouse: "ATA @ Warehouse 1",
  };
  let destinationDateSelector_Index_For_Air = {
    loaded_cfs: "Loaded @ CFS",
    dispatched_from_arrival_airport: "Dispatched from Arrival Airport	",
    actual_time_arrival_at_warehouse: "ATA @ Warehouse 1",
  };
  let destinationDateSelector_LastIndex = {
    cargo_departure_from_warehouse: 'Cargo departure from warehouse',
    estimate_delivery_date_to_consignee: "Est. Delivery Date to Consignee",
    actual_delivery_date: "Actual delivery date",
  };
if (booking.shipmentType === "LCL") {
    originDateSelector = origin_pickup_LCL;
}
if (booking.shipmentType === "FCL (Factory/Factory)") {
    originDateSelector = origin_pickup_fcl_FACTORY_FACTORY;
}
if (booking.shipmentType === "FCL (Factory/Dock)") {
    originDateSelector = origin_pickup_fcl_FACTORY_CFS;
}
if (booking.shipmentType === "FCL (Dock/Dock)") {
    originDateSelector = origin_pickup_fcl_CFS_CFS;
}
if (booking.shipmentType === "FCL (Dock/Factory)") {
    originDateSelector = origin_pickup_fcl_CFS_FACTORY;
}
if (booking.shipmentType === "Air") {
    originDateSelector = origin_pickup_AIR;
}

let destinationDateSelector;
if (booking.shipmentType === "LCL") {
    destinationDateSelector = destination_delivery_LCL;
}
if (booking.shipmentType === "FCL (Factory/Factory)") {
    destinationDateSelector = destination_delivery_fcl_FACTORY_FACTORY;
}
if (booking.shipmentType === "FCL (Factory/Dock)") {
    destinationDateSelector = destination_delivery_fcl_FACTORY_CFS;
}
if (booking.shipmentType === "FCL (Dock/Dock)") {
    destinationDateSelector = destination_delivery_fcl_CFS_CFS;
}
if (booking.shipmentType === "FCL (Dock/Factory)") {
    destinationDateSelector = destination_delivery_fcl_CFS_FACTORY;
}
if (booking.shipmentType === "Air") {
    destinationDateSelector = destination_delivery_AIR;
}
useSnapshot(myactionsstore);
useSnapshot(DtStore);
useSnapshot(configStore);
const multidest = booking?.booking?.contract?.multidest
let ret = configStore.modalvisibledata;
let st = ret.shipmentType;
let sc = ret.shipmentScope;
let tto = ret.transportTypeOrigin ? ret.transportTypeOrigin : 'FTL'
let ttd = ret.transportTypeDestination ? ret.transportTypeDestination : 'FTL'
var mdes = {}
const useLTL = multidest?.length > 1 && ret?.transportTypeMultipleDestination === undefined;
ret?.booking?.contract?.multidest.forEach((_, index) => {
  mdes[index] = useLTL ? ret.transportTypeDestination : "FTL";
});
let ttmd = ret?.transportTypeMultipleDestination ? ret.transportTypeMultipleDestination : mdes;
const [ch, setCh] = useState(0);
const [origin, setOrgin] = useState([]);
const [des, setDes] = useState([]);
const [multipleDes, setMultipleDes] = useState([]);
const [originWarehouses, setOriginWarehouses] = useState([]);
const [destinationWarehouses, setDestinationWarehouses] = useState([]);
const [transportTypeOrigin, setTransportTypeOrigin] = useState(tto);
const [transportTypeDestination, setTransportTypeDestination] = useState(ttd);
const [transportTypeMultipleDestination, setTransportTypeMultipleDestination] = useState(ttmd);
const [originDateSelectorForLTL, setOriginDateSelectorForLTL] = useState([]);
const [destinationDateSelectorForLTL, setDestinationDateSelectorForLTL] = useState([]);
const [isPicked, setisPicked] = useState(false);
const [mailPickup, setMailPickup] = useState(false);
const [mailDelivery, setMailDelivery] = useState(false);
const [isDelivered, setisDelivered] = useState(false);
const [deliveryMailed, setDeliveryMailed] = useState(false);
const [pickupMailed, setPickupMailed] = useState(false);
const [mapVisible, setMapVisible] = useState(false);
const [total_package, setTotalPackage] = useState(false);


console.log("sc---------?", ret);
console.log("originInitial---------?", booking.vorgin);
console.log("originInitial else---------?", booking.vdes);
let b = booking?.booking;
  useEffect(() => {
    let origin_destination = ""
    
    if(b?.contract?.portOfReceipt.trim().length==0){
        origin_destination = b?.contract?.portOfLoading
    }else{
        origin_destination = b?.contract?.portOfReceipt
    }
    
    let originInitial = new Array();
    if ((booking?.vorgin === undefined || booking?.vorgin?.length === 0) 
      && (sc === SHIPMENT_SCOPE.d2p || sc === SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_f_cfs) {
      let temp = EXPORT_BOOKING && LCL_OR_AIR ? 
      {terminal_cfs : origin_destination, destination: '',} : {destination: origin_destination}
      originInitial.push({
        origin: booking.origin,
        transport_ref_number: "",
        transport_name: "",
        driver_number: "",
        driver_name: "",
        vehicle: "",
        number_of_package: "",
        status: "",
        total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
        ...temp,
        ...Object.keys(originDateSelector).reduce((ele, key) => {
          ele[key] = "";
          return ele;
        }, {}),
        ...temp,
      })
    }else if (booking?.vorgin && booking?.vorgin?.length > 0 
      && (sc === SHIPMENT_SCOPE.d2p || sc === SHIPMENT_SCOPE.d2d) && (st != SHIPMENT_TYPE.fcl_f_cfs)) {
      originInitial = booking?.vorgin;
      console.log("check login-------->")
      originInitial.forEach((ele, index, originInitialArr) => {
        ele[transportTypeOrigin === 'LTL' ? index === 0 ? 'origin' : index + 1  === originInitialArr.length && originInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] = ele[transportTypeOrigin === 'LTL' ? index === 0 ? 'origin' : index + 1  === originInitialArr.length && originInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] === undefined ? '' : ele[transportTypeOrigin === 'LTL' ? index === 0 ? 'origin' : index + 1  === originInitialArr.length && originInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ];
        ele[transportTypeOrigin === 'LTL' ? index+1 === originInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] = ele[transportTypeOrigin === 'LTL' ? index+1 === originInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] === undefined ? '' : ele[transportTypeOrigin === 'LTL' ? index+1 === originInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'];
        ele.transport_ref_number = ele.transport_ref_number === undefined ? "" : ele.transport_ref_number;
        ele.transport_name = ele.transport_name === undefined ? "" : ele.transport_name;
        ele.driver_number = ele.driver_number === undefined ? "" : ele.driver_number;
        ele.driver_number = ele.driver_number === undefined ? "" : ele.driver_number;
        ele.driver_name = ele.driver_name === undefined ? "" : ele.driver_name;
        ele.vehicle = ele.vehicle === undefined ? "" : ele.vehicle;
        ele.number_of_package = ele.number_of_package === undefined ? "" : ele.number_of_package;
        ele.status = ele.status === undefined ? "" : ele.status;
        ele.total_package = ele.total_package > 0 ? ele.total_package : 
        booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0);

        if(transportTypeOrigin === 'LTL' && EXPORT_BOOKING && LCL_OR_AIR && index + 1  === originInitialArr.length) {
          ele.terminal_cfs = origin_destination
        }
        if(transportTypeOrigin === 'FTL' && EXPORT_BOOKING && LCL_OR_AIR) {
          ele.terminal_cfs = origin_destination
        }
      })
    }
    // if(originDateSelector.cargo_pickup && !originDisableStatus){
    //   let check = originInitial.map((ele) => ele.cargo_pickup === "");
    //   setOriginDisable(check)
    //   setCargoPickUp(check)
    // }
    console.log("originInitial------------------------", originInitial)
    setOrgin(originInitial);
    if(transportTypeOrigin === 'LTL' && (st === 'LCL' || st === 'Air') && ret?.vorgin?.length > 1){
      let arr = [];
      ret.vorgin.forEach((_, index, array) => {
        if(index === 0){
          arr.push(array.length === 1 ? st === 'LCL' ? origin_pickup_LCL : origin_pickup_AIR : originDateSelector_Index)
        }else if((index+1) === array.length && array.length > 1){
          arr.push(st === 'LCL' ? originDateSelector_LastIndex_For_LCL : originDateSelector_LastIndex_For_Air)
        }else{
          arr.push({
            actual_time_departed: `ATD @ Warehouse ${index}`,
            actual_time_arrival: `ATA @ Warehouse ${index+1}`,
          })
        }
      })
      let initialWHUpdate = [];
      ret.vorgin.forEach((_, index) => {
        if(index !== 0) initialWHUpdate.push(`Warehouse ${index}`)
      })
      setOriginWarehouses(initialWHUpdate)
      setOriginDateSelectorForLTL(arr)
    }

  }, [])
  useEffect(() =>{
    let destination_origin = ""
    if(b?.contract?.finalPlaceOfDelivery.trim().length==0){
        destination_origin = b?.contract?.portOfDischarge
    }else{
        destination_origin = b?.contract?.finalPlaceOfDelivery
    }
    let destinationInitial = new Array();
    if ((booking?.vdes === undefined || booking?.vdes?.length === 0) && (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) 
      && st != SHIPMENT_TYPE.fcl_cfs_f && (multidest?.length === 1 || multidest === undefined)) {
        let temp = IMPORT_BOOKING && LCL_OR_AIR
        ? {terminal_cfs : destination_origin, origin: ''} : {origin: destination_origin}
        destinationInitial.push({
          destination: booking.destination,
          transport_ref_number: "",
          transport_name: "",
          driver_number: "",
          driver_name: "",
          vehicle: "",
          number_of_package: "",
          status: "",
          total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
          ...temp,
          ...Object.keys(destinationDateSelector).reduce((ele, key) => {
            ele[key] = "";
            return ele;
          }, {}),
        })
        if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
          destinationInitial[0].container_number_vehicle = "";
        }
    }else if (booking?.vdes?.length > 0 && (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && 
      st != SHIPMENT_TYPE.fcl_cfs_f && (multidest === undefined || multidest?.length === 1) ) {
      destinationInitial = booking?.vdes;
      console.log("ret.vdes----------> 111111", booking?.vdes)
      destinationInitial.forEach((ele, index, destinationInitialArr) => {
        ele[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : index + 1  === destinationInitialArr.length && destinationInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] = ele[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : index + 1  === destinationInitialArr.length && destinationInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] === undefined ? '' : ele[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : index + 1  === destinationInitialArr.length && destinationInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ];
        ele[transportTypeDestination === 'LTL' ? index+1 === destinationInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] = ele[transportTypeDestination === 'LTL' ? index+1 === destinationInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] === undefined ? '' : ele[transportTypeDestination === 'LTL' ? index+1 === destinationInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'];
        ele.transport_ref_number = ele.transport_ref_number === undefined ? "" : ele.transport_ref_number;
        ele.transport_name = ele.transport_name === undefined ? "" : ele.transport_name;
        ele.driver_number = ele.driver_number === undefined ? "" : ele.driver_number;
        ele.driver_name = ele.driver_name === undefined ? "" : ele.driver_name;
        ele.vehicle = ele.vehicle === undefined ? "" : ele.vehicle;
        ele.number_of_package = ele.number_of_package === undefined ? "" : ele.number_of_package;
        ele.status = ele.status === undefined ? "" : ele.status;
        ele.total_package = ele.total_package > 0 ? ele.total_package :
        booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0);

        if(transportTypeDestination === 'LTL' && IMPORT_BOOKING && LCL_OR_AIR && index === 0) {
          ele.terminal_cfs = destination_origin
        }
        if(transportTypeDestination === 'FTL' && IMPORT_BOOKING && LCL_OR_AIR) {
          ele.terminal_cfs = destination_origin
        }
      })
      if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
        destinationInitial.forEach((ele) => {
          ele.container_number_vehicle = ele.container_number_vehicle === undefined ? "" : ele.container_number_vehicle;
        })
      }
    }
    // if(destinationDateSelector.actual_delivery_date && !destinationDisableStatus){
    //   let check = destinationInitial.map((ele) => ele.actual_delivery_date === "");
    //   setDestinationDisable(check)
    //   setActualDD(check)
    // }
    console.log("destinationInitial------------------------", destinationInitial)
    setDes(destinationInitial);
    if(transportTypeDestination === 'LTL' && (st === 'LCL' || st === 'Air') && ret?.vdes?.length > 1){
      let arr = [];
      ret.vdes.forEach((_, index, array) => {
        if(index === 0){
          if(array.length === 1){
            arr.push(st === 'LCL' ? destination_delivery_LCL : destination_delivery_AIR)
          }else{
            arr.push(st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_LCL)
          }  
        }else if((index+1) === array.length && array.length > 0){
          arr.push(destinationDateSelector_LastIndex)
        }else{
          arr.push({
            actual_time_departed: `ATD @ Warehouse ${index}`,
            actual_time_arrival: `ATA @ Warehouse ${index + 1}`,
          })
        }
      })
      let initialWHUpdate = [];
      ret.vdes.forEach((_, index) => {
        if(index !== 0) initialWHUpdate.push(`Warehouse ${index}`)
      })
      setDestinationWarehouses(initialWHUpdate)
      setDestinationDateSelectorForLTL(arr)
    }
    
    let multipleDestinationInitial = new Array();
    let destination;
    if((booking?.vdes === undefined || booking?.vdes.length === 0) && multidest?.length > 1 
    && (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_cfs_f){
      multidest.forEach((ele, index) => {
        let temp = IMPORT_BOOKING && LCL_OR_AIR
        ? {terminal_cfs : destination_origin, origin: ''} : {origin: destination_origin}
        let drayageDateFilter = transportTypeMultipleDestination[index] === 'DRAYAGE' 
        ? Object.fromEntries(Object.entries(destinationDateSelector).filter(([key]) => key !== 'loaded_cfs'))  : destinationDateSelector;
        destination = [{
          destination: ele.destination,
          transport_ref_number: "",
          transport_name: "",
          driver_number: "",
          driver_name: "",
          vehicle: "",
          number_of_package: "",
          status: "",
          total_package: ele.cargoDetails.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
          ...temp,
          ...Object.keys(drayageDateFilter).reduce((selector, key) => {
            selector[key] = "";
            return selector;
          }, {}),
        }];
        if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
          destination[0].container_number_vehicle = "";
        }
        multipleDestinationInitial.push(destination)
      })
      
    }
    else if(booking?.vdes && multidest?.length > 1 && 
      (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_cfs_f){
      let a = []
      for (let i = 0; i < multidest?.length; i++) {
          if(i==0){
              if(booking.vdes != undefined && booking.vdes.length > 0) {
                  a.push(booking.vdes)
              }
          }else{
              let k = i+1
              if(booking['vdes'+k] != undefined && booking['vdes'+k].length > 0) {
                  a.push(booking['vdes'+k])
              }
          }
      }
      multipleDestinationInitial = a;
      if(Object.values(transportTypeMultipleDestination).includes("LTL")){
        let warehouse = new Array();
        multipleDestinationInitial.forEach((ele, index) => {
          let temp = new Array();
          if(ele.length > 1 && transportTypeMultipleDestination[index] === 'LTL'){
            ele.forEach((e, i) => i !== 0 ? temp.push(`warehouse ${i}`) : null)
            warehouse.push(temp);
          }else{
            warehouse.push([]);
          }
        })
        setDestinationWarehouses(warehouse);

        let tempDateArray = []
        multipleDestinationInitial.forEach((ele, index) => {
            let arr = [];
            if(transportTypeMultipleDestination[index] === 'LTL'){
              ele.forEach((_, index, array) => {
              if(index === 0){
                  if(array.length === 1){
                    arr.push(st === 'LCL' ? destination_delivery_LCL : destination_delivery_AIR)
                  }else{
                    arr.push(st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_LCL)
                  }
                }else if((index+1) === array.length){
                  arr.push(destinationDateSelector_LastIndex)
                }else{
                  arr.push({
                    actual_time_departed: `ATD @ Warehouse ${index}`,
                    actual_time_arrival: `ATA @ Warehouse ${index + 1}`,
                  })
                }
              })
            } 
            
            tempDateArray.push(arr)
        })
        multipleDestinationInitial = multipleDestinationInitial.map(innerArray =>
        innerArray.map((obj, index) => index === 0 && IMPORT_BOOKING
        ? {...obj, terminal_cfs: destination_origin} : {...obj}));
        setDestinationDateSelectorForLTL(tempDateArray)
      }
      
    }
    // if(multipleDestinationInitial.length > 0 && destinationDateSelector.actual_delivery_date && !destinationDisableStatus){
    //   let check = multipleDestinationInitial.map((ele) => ele.map(e => e.actual_delivery_date === ""));
    //   setDestinationDisable(check)
    //   setActualDD(check)
    // }
    setMultipleDes(multipleDestinationInitial)
    
  }, [])

const areAllCargoPickupFilled = () => {
    // Check if any cargo_pickup field is empty
    for (let i = 0; i < origin.length; i++) {
    if (!origin[i].cargo_pickup) {
        return false; // Return false if any cargo_pickup field is empty
    }
    }
    return true; // Return true if all cargo_pickup fields are filled
};
const areAllCargoDeliveryFilled = () => {
    // Check if any cargo_pickup field is empty
    for (let i = 0; i < des.length; i++) {
    if (!des[i].actual_delivery_date) {
        return false; // Return false if any cargo_pickup field is empty
    }
    }
    return true; // Return true if all cargo_pickup fields are filled
};

const handlePicked = () => {
    if (areAllCargoPickupFilled()) {
    setisPicked(!isPicked);
    } else {
    setMailPickup(false);
    setisPicked(false);
    }
};

const handlePickToggle = () => {
    if (areAllCargoPickupFilled()) {
    setMailPickup(!mailPickup);
    } else {
    setMailPickup(false);
    }
};
const handleDeliveryToggle = () => {
    if (areAllCargoDeliveryFilled()) {
    setMailDelivery(!mailDelivery);
    } else {
    setMailDelivery(false);
    }
};
const handleDelivered = () => {
    if (areAllCargoDeliveryFilled()) {
    setisDelivered(!isDelivered);
    } else {
    setisDelivered(false);
    }
};
const seorde = () => {
    setPickupMailed(ret.picked !== true);
    setDeliveryMailed(ret.delivered !== true);
    if (sc == "Port-to-Door" || sc == "Door-to-Door") {
    if (ret.vdes != undefined && ret.vdes.length > 0) {
        setDes(ret.vdes);
    }
    }
    if (sc == "Door-to-Port" || sc == "Door-to-Door") {
    if (ret.vorigin != undefined && ret.vorigin.length > 0) {
        setOrgin(ret.vorigin);
    }
    }
    changech();
};

const changech = () => {
    if (ch == 0) {
    setCh(1);
    } else {
    setCh(0);
    }
};

let formRows;
  if (EXPORT_BOOKING) {
    formRows = origin;
  }
  if ((IMPORT_BOOKING && multidest?.length === 1) ||
  IMPORT_BOOKING && multidest === undefined) {
    formRows = des;
  }
  if (IMPORT_BOOKING && multidest?.length > 1) {
    formRows = multipleDes;
  }


// const checkMultiDestinationValid = (formRows, outerIndex, index) => {
//   let multidestValidation = validationError.map((outerArray) => 
//     outerArray.map((innerObj) => ({ ...innerObj }))
//   );
//   let driverNumber = [];
//   formRows.map((row) => row.map((ele) => driverNumber.push(ele.driver_number) ));
//   let uniquePhNumber = new Set(driverNumber);
//   multidestValidation[outerIndex][index].origin = formRows[outerIndex][index].origin !== "";
//   multidestValidation[outerIndex][index].destination = formRows[outerIndex][index].destination !== "";
//   multidestValidation[outerIndex][index].driver_number =
//     formRows[outerIndex][index].driver_number !== "" &&
//     formRows[outerIndex][index].driver_number.length === 10 && driverNumber.length === uniquePhNumber.size;
//   multidestValidation[outerIndex][index].vehicle = formRows[outerIndex][index].vehicle !== "";

//   if (formRows[outerIndex].length == 1) {
//     multidestValidation[outerIndex][index].number_of_package =
//       formRows[outerIndex][index].number_of_package !== "" &&
//       formRows[outerIndex][index].number_of_package <=
//       formRows[outerIndex][index].total_package;
//     multidestValidation[outerIndex][index].total_package =
//       formRows[outerIndex][index].total_package !== "" &&
//       formRows[outerIndex][index].total_package > 0;
//   }

//   if (formRows[outerIndex].length > 1) {
//     let number_of_package = formRows[outerIndex].reduce((sum, obj) => {
//       return sum + (parseInt(obj.number_of_package) || 0);
//     }, 0);
//     multidestValidation[outerIndex][index].number_of_package =
//       number_of_package <= +formRows[outerIndex][0].total_package &&
//       formRows[outerIndex][index].number_of_package !== "" &&
//       formRows[outerIndex][index].number_of_package <=
//       formRows[outerIndex][index].total_package;
//     multidestValidation[outerIndex][index].total_package =
//       number_of_package <= +formRows[outerIndex][0].total_package &&
//       formRows[outerIndex][index].total_package !== "" &&
//       formRows[outerIndex][index].total_package > 0;
//   }
//   setValidationError(multidestValidation);
//   return multidestValidation;
// };

// const checkValid = (formRows, index) => {
//   let validation = validationError.map((innerObj) => ({ ...innerObj }))
//   validation[index].origin = formRows[index].origin !== "";
//   validation[index].destination =
//     formRows[index].destination !== "";
//   validation[index].driver_number =
//     formRows[index].driver_number !== "" &&
//     formRows[index].driver_number.length === 10;
//   validation[index].vehicle = formRows[index].vehicle !== "";

//   if (formRows.length == 1) {
//     validation[index].number_of_package =
//       formRows[index].number_of_package !== "" &&
//       formRows[index].number_of_package <=
//         formRows[index].total_package;
//     validation[index].total_package =
//       formRows[index].total_package !== "" &&
//       formRows[index].total_package > 0;
//   }

//   if (formRows.length > 1) {
//     let number_of_package = formRows.reduce((sum, obj) => {
//       return sum + (parseInt(obj.number_of_package) || 0);
//     }, 0);
//     validation[index].number_of_package =
//       number_of_package <= +formRows[0].total_package &&
//       formRows[index].number_of_package !== "" &&
//       formRows[index].number_of_package <=
//         formRows[index].total_package;
//     validation[index].total_package =
//       number_of_package <= +formRows[0].total_package &&
//       formRows[index].total_package !== "" &&
//       formRows[index].total_package > 0;
//   }
//   setValidationError(validation);
//   return validation;
// };

// const handleChange = (index, outerIndex) => {
//   let error;
//   if(multipleDes && multipleDes.length > 0){
//     error = checkMultiDestinationValid(formRows, outerIndex, index);
//   }else{
//     error = checkValid(formRows, index);
//   }
//   console.log("error--------------", error)
//   let checked = multipleDes && multipleDes.length > 0 ? 
//   Object.values(error[outerIndex][index]).every((value) => value === true) :
//   Object.values(error[index]).every((value) => value === true);
//   if ((checked && (formRows[index].status === "" || formRows[index].status === "PENDING")) 
//     || (checked && (formRows[outerIndex][index].status === "" || formRows[outerIndex][index].status === "PENDING"))) {
//     Api.checkPhNumber(
//       { driver_number: multipleDes && multipleDes.length > 0 ? 
//         formRows[outerIndex][index].driver_number : formRows[index].driver_number },
//       async (result) => {
//         configStore.setModalMessage(result.data);
//         if (result.status === "PENDING") {
//           multipleDes && multipleDes.length > 0 ? 
//           formRows[outerIndex][index] = result.status
//           : formRows[index].status = result.status;
//         }
//         if (result.data === "ALLOWED") {
//           multipleDes && multipleDes.length > 0 ? 
//           formRows[outerIndex][index] = "APPROVED"
//           : formRows[index].status = "APPROVED";
            
//         }
//         // if (result.status === "PENDING") {
//         //   // Need to check mobile status
//         //   formRows[index].status = result.status;
//         // }
//       }
//     );
//   } else if ((checked && formRows[index].status === "APPROVED") || checked && formRows[outerIndex][index].status === "APPROVED") {
//     if(booking.tracking[index].tripDetails){
//       DtStore.modalVisible2 = true;
//       DtStore.MapUrl = booking.tracking[index].tripDetails.publiclink;
//     } else{
//       let trackingData = { bookingId: booking._id, entityId: booking.entityId, trackingRow: formRows[index] }
//       Api.startTrip(trackingData, async (data) => {
//           DtStore.MapUrl = data.result.publiclink;
//           DtStore.modalVisible2 = true;
//         }
//       );
//     }
//   } 
//   // else {
//   //   configStore.setModalMessage("Please check all fields");
//   // }
// };

function convertDateFormat(dateStr) {
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateFormatRegex.test(dateStr)) {
        return dateStr;
    }
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
}
let modalClass = "modal";
if (myactionsstore.vviewModalVisible) modalClass += " is-active";
console.log("2409LCLCEN05710016 origin", origin)
console.log("2409LCLCEN05710016 des", des)
console.log("2409LCLCEN05710016 multipleDes", multipleDes)
return (
    <>
        
        <div className={modalClass}>
        <div className="modal-background"></div>
        <div
            className="modal-card"
            onClick={(e) => {
            e.stopPropagation();
            }}
            style={{ borderRadius: "10px", width: "95%" }}
        >
            <section className="modal-card-body">
            <div
                className="table-container"
                onClick={(e) => e.stopPropagation()}
            >
                {(sc == "Door-to-Port" || sc == "Door-to-Door") &&
                st != "FCL (Factory/Dock)" && origin && origin.length > 0 ? (
                <>
                    <div>
                    <div class="px-5 py-2 flex align-center justify-between">
                        <p class="text-base font-semibold">Origin Pick-up</p>
                        <div>
                        <div class="flex align-center">
                            <p class="text-base font-semibold">
                            Total No. of Packages: {(+origin[0].total_package)}
                            </p>
                        </div>
                        </div>
                        { ret.shipmentType === 'LCL' || ret.shipmentType === 'Air' ? 
                          <div class="flex items-center space-x-4">
                            <span class="font-bold">Transport Type:</span>
                            <label class="flex items-center space-x-2">
                                <input checked={transportTypeOrigin === "FTL"} type="radio" name="transportTypeOrigin" value="FTL"
                                  disabled={true}
                                class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>FTL</span>
                            </label>
                            <label class="flex items-center space-x-2">
                                <input checked={transportTypeOrigin === "LTL"} type="radio" name="transportTypeOrigin" value="LTL"
                                  disabled={true}
                                  class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>LTL</span>
                            </label>
                          </div> : <div></div>
                        }
                    </div>
                    {origin.map((e, i) => {
                        return (
                            <div
                            id={i + "0"}
                            key={i + "0"}
                            class="mb-5 p-5 bg-custom-gray rounded-md"
                            >
                            <div class="ml-4 flex align-center">
                                {e.consent === 'UNKNOWN' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'>Driver Status: {`Invalid Driver Number`}</button>}
                                {e.consent === 'PENDING' ?
                                <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Driver Status: {e.consent}</button>
                                :
                                <>
                                    { e.consent === 'ALLOWED' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Trip Status: {e.tripstatus}</button>} 
                                </>}
                                </div>
                            <div class="flex justify-between">
                                <div></div>
                                <div class="flex align-center">
                                <p class="text-sm font-semibold">
                                    {transportTypeOrigin === 'LTL' 
                                    ? `${'Leg ' + [i + 1]}` : `${'Vehicle ' + [i + 1]}`}
                                </p>  
                                </div>
                                <div class="flex">
                                { e.tripstatus === 'started' && e.consent == 'ALLOWED' && EXPORT_BOOKING ? 
                                    <button
                                    class='bg-[#C9DEFF] p-1 border-0 rounded-md'
                                >
                                    <img src={TrackIcon} 
                                    onClick={()=>{
                                    console.log("changes------------>", e.publiclink)
                                    if(e.publiclink !== undefined && e.publiclink != ''){
                                        DtStore.MapUrl = e.publiclink
                                        DtStore.modalVisible2 = true
                                        setMapVisible(true)
                                    }
                                    }}
                                    alt="track"/>
                                </button>: ""}
                                </div>
                            </div>
                            <div class="flex py-2">
                                <div class="flex w-[50%]">
                                {
                                    LCL_OR_AIR ? 
                                    <>
                                    <div class="w-2/4 px-4">
                                        <p class="text-sm">{transportTypeOrigin === 'LTL' ? i === 0 ? 'Origin*'
                                        : `${originWarehouses[i-1]}*` : 'Origin*'}</p>
                                        <OneInput5table
                                        disabled={true}
                                        search={true}
                                        name={transportTypeOrigin === 'LTL' ? (i === 0 ) ? 'origin' : (i + 1 === origin.length && origin.length > 1) 
                                            ? `warehouse_${i}` : `warehouse_${i}` : 'origin'}
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Origin"
                                        />
                                    </div>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">{transportTypeOrigin === 'LTL' ? origin.length - 1 === i 
                                    ? EXPORT_BOOKING ? `Destination* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Destination*'
                                    : `${originWarehouses[i]}*` : EXPORT_BOOKING ? `Destination* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Destination*'}</p>
                                    <OneInput5table
                                        disabled={true}
                                        search={true}
                                        name={transportTypeOrigin === 'LTL' ? (i === 0 && origin.length > 1) ? `warehouse_${i+1}` : 
                                        i + 1 === origin.length ?  'destination' : `warehouse_${i+1}` : 'destination'}
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Destination"
                                    />
                                    </div>
                                </> : 
                                <>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">Origin*</p>
                                    <OneInput5table
                                        disabled={true}
                                        name="origin"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Origin"
                                    />
                                    </div>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">Destination*</p>
                                    <OneInput5table
                                        name="destination"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Destination"
                                    />
                                    </div>
                                </>
                                }
                                </div>
                                <div class="flex w-[50%]">
                                  <div class="w-2/4 px-4">
                                      <p class="text-sm">Transporter Ref Number</p>
                                      <OneInput5table
                                      disable={false}
                                      name="transport_ref_number"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Transporter Ref Number"
                                      />
                                  </div>
                                  <div class="w-2/4 px-4">
                                      <p class="text-sm">Transporter Name</p>
                                      <OneInput5table
                                      disabled={true}
                                      search={true}
                                      name="transport_name"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Transporter Name"
                                      />
                                  </div>
                                <div class="w-2/4 px-4">
                                    <p class="text-sm">{`${transportTypeOrigin === 'LTL' ? i === 0 ? 'No. of Packages*' : 'No. of Packages' : 'No. of Packages*'}`}</p>
                                    <OneInput5table
                                    disable={false}
                                    name="number_of_package"
                                    label="Number Of Package"
                                    record={e}
                                    />
                                </div>
                                </div>
                            </div>
                            <div class="flex px-2 py-2">
                                <div class="w-full px-2">
                                <p class="text-sm">{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle Number*' : 'Vehicle Number'}`}</p>
                                <OneInput5table
                                    disable={false}
                                    name="vehicle"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Vehicle#"
                                />
                                </div>
                                <div class="w-full px-2">
                                <p class="text-sm">Driver Number{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? '*' : ''}`}</p>
                                <OneInput5table
                                    disable={false}
                                    name="driver_number"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Driver Number"
                                />
                                </div>
                                <div class="w-full px-2">
                                <p class="text-sm">Driver Name</p>
                                <OneInput5table
                                    disable={false}
                                    name="driver_name"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Driver Name"
                                />
                                </div>
                                {Object.entries(transportTypeOrigin === 'LTL' && originDateSelectorForLTL?.length > 0 
                                ? originDateSelectorForLTL[i] : originDateSelector).map(
                                ([key, value], index) => (
                                    <div className="w-full px-2" key={index}>
                                    <p className="text-sm">{value}</p>
                                    <input
                                        disabled= {true}
                                        type="date"
                                        value={convertDateFormat(e[key])}
                                        className="border-solid border w-full rounded-md p-1.5"
                                        id={key}
                                        name={key}
                                    />
                                    </div>
                                )
                                )}
                            </div>
                            </div>
                        );
                        })}
                    </div>
                </>
                ) : (
                <></>
                )}
                {(sc == "Port-to-Door" || sc == "Door-to-Door") && 
                st != "FCL (Dock/Factory)" && des && des.length > 0 ? (
                <>
                    <div>
                    <div class="px-5 py-2 flex align-center justify-between">
                        <p class="text-base font-semibold">Destination Delivery</p>
                        <div>
                        <div class="flex align-center">
                            <p class="text-base font-semibold">
                            Total No. of Packages: {(+des[0].total_package)}
                            </p>
                        </div>
                        </div>
                        { ret.shipmentType === 'LCL' || ret.shipmentType === 'Air' ? 
                        <div class="flex items-center space-x-4">
                          <span class="font-bold">Transport Type:</span>
                          {st !== SHIPMENT_TYPE.air && 
                          <label class="flex items-center space-x-2">
                            <input checked={transportTypeDestination === "DRAYAGE"} type="radio" name="transport" value="DRAYAGE"
                              disabled={true}
                            class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                            <span>DRAYAGE</span>
                          </label>}
                          <label class="flex items-center space-x-2">
                              <input checked={transportTypeDestination === "FTL"} type="radio" name="transport" value="FTL"
                              disabled={true}
                              class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                              <span>FTL</span>
                          </label>
                          <label class="flex items-center space-x-2">
                              <input checked={transportTypeDestination === "LTL"} type="radio" name="transport" value="LTL"
                              disabled={true}
                              class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                              <span>LTL</span>
                          </label>
                        </div> : <div></div>
                      }
                    </div>
                    { des && des.length > 0 ? des.map((e, i) => {
                        return (
                        <div class="mb-5 p-5 bg-custom-gray rounded-md">
                            <div class="flex justify-between">
                            <div class="ml-4 flex align-center"> 
                              {e.consent === 'UNKNOWN' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'>Driver Status: {`Invalid Driver Number`}</button>}
                            {(e.consent === 'PENDING') && e?.tripstatus !== 'completed' ?
                                <>
                                <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Driver Status: {e.consent}</button>
                                </>:
                                <>
                                { e.consent === 'ALLOWED' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Trip Status: {e.tripstatus}</button>} 
                                </>}
                            </div>
                            <div class="flex align-center">
                                <p class="text-sm font-semibold">
                                {transportTypeDestination === 'LTL' 
                                ? `${'Leg ' + [i + 1]}` : `${'Vehicle ' + [i + 1]}`}
                                </p>
                            </div>
                            <div class="flex">
                                { e.tripstatus === 'started'  && e.consent == 'ALLOWED' && IMPORT_BOOKING ? 
                                <button
                                class='bg-[#C9DEFF] p-1 border-0 rounded-md'
                                >
                                <img src={TrackIcon} 
                                onClick={()=>{
                                    if(e.publiclink !== undefined && e.publiclink != ''){
                                    DtStore.MapUrl = e.publiclink
                                    DtStore.modalVisible2 = true
                                    setMapVisible(true)
                                    }
                                }}
                                    alt="track"/>
                                </button>: ""}
                            </div>
                            </div>
                            <div class="flex py-2">
                            <div class="flex w-[50%]">
                                {
                                LCL_OR_AIR ? 
                                <>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">{transportTypeDestination === 'LTL' ? i === 0 ? IMPORT_BOOKING ?
                                    `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'
                                    : `${destinationWarehouses[i-1]}*` : IMPORT_BOOKING 
                                    ? `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'}</p>
                                    <OneInput5table
                                        disabled={true}
                                        search={true}
                                        name={transportTypeDestination === 'LTL' ? (i === 0 ) ? 'origin' : (i + 1 === des.length && des.length > 1) 
                                        ? `warehouse_${i}` : `warehouse_${i}` : 'origin'}
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Origin"
                                    />
                                    </div>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">{transportTypeDestination === 'LTL' ? des.length - 1 === i ? 'Destination*'
                                    : `${destinationWarehouses[i]}*` : 'Destination*'}</p>
                                    <OneInput5table
                                        disabled={true}
                                        search={true}
                                        name={transportTypeDestination === 'LTL' ? (i === 0 && des.length > 1) ? `warehouse_${i+1}` : 
                                            i + 1 === des.length ?  'destination' : `warehouse_${i+1}` : 'destination'}
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Destination"
                                    />
                                    </div>
                                </> : 
                                <>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">Origin*</p>
                                    <OneInput5table
                                        disabled={true}
                                        name="origin"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Origin"
                                    />
                                    </div>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">Destination*</p>
                                    <OneInput5table
                                        disabled={true}
                                        name="destination"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Destination"
                                    />
                                    </div>
                                </>
                                }
                                { (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs) &&
                                <div class="w-2/4 px-4">
                                    <p class="text-sm">Container Number*</p>
                                    <OneInput5table
                                    disabled={true}
                                    name="container_number_vehicle"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Container Number"
                                    />
                                </div>
                                }
                            </div>
                            <div class="flex w-[50%]">
                                <div class="w-2/4 px-4">
                                <p class="text-sm">Transporter Ref Number</p>
                                <OneInput5table
                                    disable={false}
                                    name="transport_ref_number"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Transporter Ref Number"
                                />
                                </div>
                                <div class="w-2/4 px-4">
                                <p class="text-sm">Transporter Name</p>
                                <OneInput5table
                                    disabled={true}
                                    search={true}
                                    name="transport_name"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Transporter Name"
                                />
                                </div>
                                <div class="w-2/4 px-4">
                                <p class="text-sm">{`${transportTypeDestination === 'LTL' ? i === 0 ? 'No. of Packages*' : 'No. of Packages' : 'No. of Packages*'}`}</p>
                                <OneInput5table
                                    disable={false}
                                    name="number_of_package"
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Number Of Package"
                                />
                                </div>
                            </div>
                            </div>
                            <div class="flex px-2 py-2">
                            <div class="w-full px-2">
                                <p class="text-sm">{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle Number*' : 'Vehicle Number'}`}</p>
                                <OneInput5table
                                disable={false}
                                name="vehicle"
                                record={JSON.parse(JSON.stringify(e))}
                                label="Vehicle#"
                                />
                            </div>
                            <div class="w-full px-2">
                                <p class="text-sm">Driver Number{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? '*' : ''}`}</p>
                                <OneInput5table
                                disable={false}
                                name="driver_number"
                                record={JSON.parse(JSON.stringify(e))}
                                label="Driver Number"
                                />
                            </div>
                            <div class="w-full p  x-2">
                                <p class="text-sm">Driver Name</p>
                                <OneInput5table
                                disable={false}
                                name="driver_name"
                                record={JSON.parse(JSON.stringify(e))}
                                label="Driver Name"
                                />
                            </div>
                            {Object.entries(transportTypeDestination === 'LTL' && destinationDateSelectorForLTL?.length > 0 
                            ? destinationDateSelectorForLTL[i] : destinationDateSelector).map(
                            ([key, value], index) => {
                                let minDate = "";

                                // Get the list of keys
                                const keysArray = Object.keys(ACTUALSLIST);
                                const keyIndex = keysArray.indexOf(key);

                                if (keyIndex > 0) {
                                for (let i = keyIndex - 1; i >= 0; i--) {
                                    const prevKey = keysArray[i];

                                    // Check directly in ret
                                    if (ret[prevKey]) {
                                    minDate = ret[prevKey];
                                    break;
                                    }

                                    let latestDate = "";

                                    for (const listKey of arrayListsinDsr) {
                                    if (Array.isArray(ret[listKey])) { 
                                        for (const item of ret[listKey]) { 
                                        if (item[prevKey] && (!latestDate || new Date(item[prevKey]) > new Date(latestDate))) {
                                            latestDate = item[prevKey];
                                        }
                                        }
                                    }
                                    }
                                    if (latestDate) {
                                    minDate = latestDate;
                                    break;
                                    }
                                }
                                } return(
                                <div className="w-full px-2" key={index}>
                                    <p className="text-sm">{value}</p>
                                    <input
                                    disabled= {true}
                                    type="date"
                                    value={convertDateFormat(e[key])}
                                    className="border-solid border w-full rounded-md p-1.5"
                                    id={key}
                                    name={key}
                                    />
                                </div>
                                )
                            })}
                            </div>
                        </div>
                        )
                    }) : <></>}
                    </div>
                </>
                ) : (
                <></>
                )}

                {(sc == "Port-to-Door" || sc == "Door-to-Door") && st != "FCL (Dock/Factory)"
                && multipleDes && multipleDes.length > 0 ? multipleDes.map((ele, index) =>{
                return (
                    <div key={index + "1"}>
                    <div class="px-5 py-2 grid grid-cols-3 items-center w-full">
                        <p class="text-base font-semibold">
                        Destination Delivery: {index + 1} 
                        </p>
                        <p class="text-base font-semibold col-start-2 col-span-1 text-center">
                            Total No. of Packages: 
                            {(+multipleDes[index][0].total_package)}
                        </p>
                        {(ret.shipmentType === 'LCL' || ret.shipmentType === 'Air') ? 
                          <div class="flex items-center ml-auto space-x-4">
                            <span class="font-bold">Transport Type:</span>
                            {st !== SHIPMENT_TYPE.air && 
                            <label class="flex items-center space-x-2">
                              <input  key={index} checked={transportTypeMultipleDestination[index] === "DRAYAGE"} type="radio" 
                              name={`transportTypeMultipleDestination-${index}`} value="DRAYAGE"
                              disabled={true}
                              class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                              <span>DRAYAGE</span>
                            </label>}
                            <label class="flex items-center space-x-2">
                                <input  key={index} checked={transportTypeMultipleDestination[index] === "FTL"} type="radio" 
                                name={`transportTypeMultipleDestination-${index}`} value="FTL"
                                disabled={true}
                                class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>FTL</span>
                            </label>
                            <label class="flex items-center space-x-2">
                                <input key={index+1} checked={transportTypeMultipleDestination[index] === "LTL"} type="radio" 
                                name={`transportTypeMultipleDestination-${index}`} value="LTL"
                                disabled={true}
                                class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>LTL</span>
                            </label>
                          </div> : <div></div>
                        }
                    </div>
                    {
                        ele.map((e, i, desArr) => {
                          return(
                            <div key={i+"11"}>
                              <div class="mb-5 p-5 bg-custom-gray rounded-md">
                                <div class="flex justify-between">
                                  <div class="ml-4 flex align-center">
                                    {e.consent === 'UNKNOWN' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'>Driver Status: {`Invalid Driver Number`}</button>}
                                    {e.consent === 'PENDING'? 
                                    <>
                                    <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Driver Status: {e.consent}</button>
                                    </>:
                                    <>
                                      { e.consent === 'ALLOWED' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Trip Status: {e.tripstatus}</button>} 
                                    </>}
                                  </div>
                                  <div class="flex align-center">
                                    <p class="text-sm font-semibold">
                                    {transportTypeMultipleDestination[index] === 'LTL' 
                                      ? `${'Leg ' + [i + 1]}` : `${'Vehicle ' + [i + 1]}`}
                                    </p>
                                  </div>
                                  <div class="flex">
                                    { e.tripstatus === 'started'  && e.consent == 'ALLOWED' && IMPORT_BOOKING ? 
                                      <button
                                      class='bg-[#C9DEFF] p-1 border-0 rounded-md'
                                      >
                                        <img src={TrackIcon} 
                                          onClick={()=>{
                                            if(e.publiclink !== undefined && e.publiclink != ''){
                                              DtStore.MapUrl = e.publiclink
                                              DtStore.modalVisible2 = true
                                              setMapVisible(true)
                                            }
                                          }}
                                          alt="track"/>
                                      </button>: ""
                                    }
                                  </div>
                                </div>
                                <div class="flex py-2">
                                  <div class="flex w-[50%]">
                                    {
                                      LCL_OR_AIR ? 
                                      <>
                                        <div class="w-2/4 px-4">
                                          <label class="text-sm">{transportTypeMultipleDestination[index] === 'LTL' ? i === 0 ?
                                          IMPORT_BOOKING ? `Origin* - ${e?.terminal_cfs || ''}` : 'Origin*'
                                          : `${destinationWarehouses[index][i-1]}*` : IMPORT_BOOKING ? `Origin* - ${e?.terminal_cfs || ''}` : 'Origin*'}</label>
                                          <OneInput5table
                                            disabled={true}
                                            search={true}
                                            name={transportTypeMultipleDestination[index] === 'LTL' ? (i === 0 ) ? 'origin' : (i + 1 === desArr.length && desArr.length > 1) 
                                              ? `warehouse_${i}` : `warehouse_${i}` : 'origin'}
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Origin"
                                          />
                                        </div>
                                        <div class="w-2/4 px-4">
                                          <label htmlFor='warehouse 1' class="text-sm">{transportTypeMultipleDestination[index] === 'LTL' ? ele.length - 1 === i 
                                          ? 'Destination*' : `${destinationWarehouses[index][i]}*` : 'Destination*'}</label>
                                          <OneInput5table
                                            disabled={true}
                                            search={true}
                                            name={transportTypeMultipleDestination[index] === 'LTL' ? (i === 0 && desArr.length > 1) ? `warehouse_${i+1}` : 
                                                i + 1 === desArr.length ?  'destination' : `warehouse_${i+1}` : 'destination'}
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Destination"
                                          />
                                        </div>
                                      </> : 
                                      <>
                                        <div class="w-2/4 px-4">
                                          <p class="text-sm">Origin*</p>
                                          <OneInput5table
                                            disabled={true}
                                            name="origin"
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Origin"
                                            errorMsg="Origin is required"
                                          />
                                        </div>
                                        <div class="w-2/4 px-4">
                                          <p class="text-sm">Destination*</p>
                                          <OneInput5table
                                            disabled={true}
                                            name="destination"
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Destination"
                                          />
                                        </div>
                                      </>
                                    }
                                    { (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs) &&
                                      <div class="w-2/4 px-4">
                                        <p class="text-sm">Container Number*</p>
                                        <OneInput5table
                                          disabled={true}
                                          name="container_number_vehicle"
                                          record={JSON.parse(JSON.stringify(e))}
                                          label="Container Number"
                                        />
                                      </div>
                                    }
                                  </div>
                                  <div class="flex w-[50%]">
                                    <div class="w-2/4 px-4">
                                      <p class="text-sm">Transporter Ref Number</p>
                                      <OneInput5table
                                        disable={false}
                                        name="transport_ref_number"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Transporter Ref Number"
                                      />
                                    </div>
                                    <div class="w-2/4 px-4">
                                      <p class="text-sm">Transporter Name</p>
                                      <OneInput5table
                                        disabled={true}
                                        name="transport_name"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Transporter Name"
                                      />
                                    </div>
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">{`${transportTypeMultipleDestination[index] === 'LTL' ? i === 0 ? 'No. of Packages*' : 'No. of Packages' : 'No. of Packages*'}`}</p>
                                      <OneInput5table
                                        disable={false}
                                        name="number_of_package"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Number Of Package"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="flex px-2 py-2">
                                  <div class="w-full px-2">
                                    <p class="text-sm">{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle Number*' : 'Vehicle Number'}`}</p>
                                    <OneInput5table
                                      disable={false}
                                      name="vehicle"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Vehicle#"
                                    />
                                  </div>
                                  <div class="w-full px-2">
                                    <p class="text-sm">Driver Number{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? '*' : ''}`}</p>
                                    <OneInput5table
                                      disable={false}
                                      name="driver_number"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Driver Number"
                                    />
                                  </div>
                                  <div class="w-full px-2">
                                    <p class="text-sm">Driver Name</p>
                                    <OneInput5table
                                      disable={false}
                                      name="driver_name"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Driver Name"
                                    />
                                  </div>
                                  {Object.entries((transportTypeMultipleDestination[index] === 'LTL' && destinationDateSelectorForLTL?.length > 0 
                              ? destinationDateSelectorForLTL[index][i] : transportTypeMultipleDestination[index] === 'DRAYAGE' ? Object.fromEntries(
                                  Object.entries(destinationDateSelector).filter(([key]) => key !== 'loaded_cfs')
                                ) : destinationDateSelector)).map(
                                    ([key, value], destinationDateSelectorIndex) => {
  let minDate = "";
  const keysArray = Object.keys(ACTUALSLIST);
  const keyIndex = keysArray.indexOf(key);

  if (keyIndex > 0) {
    for (let i = keyIndex - 1; i >= 0; i--) {
      const prevKey = keysArray[i];

      if (ret?.[prevKey]) {
        minDate = ret[prevKey];
        break;
      }

      let latestDate = "";

      for (const listKey of arrayListsinDsr) {
        if (Array.isArray(ret?.[listKey])) {
          for (const item of ret?.[listKey]) {
            if (item?.[prevKey] && (!latestDate || new Date(item?.[prevKey]) > new Date(latestDate))) {
              latestDate = item[prevKey];
            }
          }
        }
      }

      if (latestDate) {
        minDate = latestDate;
        break;
      }
    }
  }

  const formattedMinDate = minDate ? minDate.split("-").reverse().join("-") : "";

  return (
    <div className="w-full px-2" key={destinationDateSelectorIndex}>
      <p className="text-sm">{value}</p>
      <input
        disabled= {true}
        type="date"
        value={convertDateFormat(e[key])}
        className="border-solid border w-full rounded-md p-1.5"
        id={key}
        name={key}
        onChange={(event) => {
          const newdes = multipleDes.map((outerItem, oIdx) =>
            oIdx === index
              ? outerItem.map((item, iIdx) =>
                  iIdx === i ? { ...item, [key]: event.target.value } : item
                )
              : outerItem
          );
          setMultipleDes(newdes);
        }}
      />
    </div>
  );
})}
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                )
                })
                : <></> }
                <div class="mt-5 flex justify-end">
                  <button
                    class="w-24 mr-3 h-9 text-red border-0 border-slate-800 bg-custom-gray px-4 py-2 border-transparent text-red font-semibold rounded-md"
                    onClick={() => (myactionsstore.vviewModalVisible = false)}
                  >
                    Close
                  </button>
                </div>
            </div>
            </section>
        </div>
        </div>
        { mapVisible && <DtMap /> }
    </>
);
};
    
